import React from "react";
import logo from "../../../assets/images/Footer/msquaredlogo-e1644692681953 1.png";
import "./Footer.css";

import linkedin from "../../../assets/images/Footer/social/Vector(6).png";
import insta from "../../../assets/images/Footer/social/Social Icons.png";
import x from "../../../assets/images/Footer/social/Vector(8).png";
import youtube from "../../../assets/images/Footer/social/Vector(9).png";
import fb from "../../../assets/images/Footer/social/Vector(10).png";
import { Link } from "react-router-dom";

function Footer({ executeScroll, executeScrollContact, executeScrollAboutus,executeScrollHome }) {
  return (
    <div className="footer">
      <div className="footer-basic">
        <footer>
          <div className="footer-main">
            <Link
              href="/"
              className="d-flex align-items-center mb-3 link-dark text-decoration-none"
            >
              <img src={logo} className="footer-logo" alt="logo"/>
            </Link>
            <p className="footer-text">
            Empowering Futures, Where Skills Meet Innovation
            </p>
          </div>
          <div className="social">
            <Link
              target="_blank"
              to="https://in.linkedin.com/in/m-squared-training-and-development-center-a46527228/"
              className="nav-link p-0 footer-list-text"
            >
              <img src={linkedin} alt="linkedin"/>
            </Link>
            <Link
              target="_blank"
              to="https://www.instagram.com/msquared_training_center/"
              className="nav-link p-0 footer-list-text"
            >
              <img src={insta} alt="instagram"/>
            </Link>
            <Link
              target="_blank"
              to="https://www.youtube.com/channel/UCN8DlLQHTVNyYTpKglO-q0w"
              className="nav-link p-0 footer-list-text"
            >
              <img src={youtube} alt="youtube"/>
            </Link>
            <Link
              target="_blank"
              to="https://www.facebook.com/trainingm2"
              className="nav-link p-0 footer-list-text"
            >
              <img src={fb} alt="facebook"/>
            </Link>
          </div>
          <ul className="list-inline">
            <li className="list-inline-item">
              <Link onClick={executeScrollHome}>Home</Link>
            </li>
            <li className="list-inline-item">
              <Link onClick={executeScroll}>Courses</Link>
            </li>
            <li className="list-inline-item">
              <Link onClick={executeScrollAboutus}>About us</Link>
            </li>
            <li className="list-inline-item">
              <Link onClick={executeScrollContact}>Contact</Link>
            </li>
          </ul>
          <hr style={{background:"white",height:"2px", width:"700px", margin:"20px auto"}} />
          <ul className="list-inline">  
            <li className="list-inline-item">
              <Link to="https://m2elearning.com/front/faq" target="_blank">FAQ</Link>
            </li>
            <li className="list-inline-item">
              <Link to="https://m2elearning.com/front/blog" target="_blank">Blog</Link>
            </li>
            <li className="list-inline-item">
              <Link to="https://m2elearning.com/front/privacy" target="_blank">Privacy Policy</Link>
            </li>
            <li className="list-inline-item">
              <Link to="https://m2elearning.com/front/terms" target="_blank"> Terms & Conditions</Link>
            </li>   
          </ul>
          <p className="copyright">
            COPYRIGHT © 2024 M-SQUARED TRAINING CENTER | ALL RIGHTS RESERVED
          </p>
        </footer>
      </div>

      {/* <div className="container">
        <footer className="row row-cols-5 py-5 my-5 border-top">
          <div className="col-6">
            <a
              href="/"
              className="d-flex align-items-center mb-3 link-dark text-decoration-none"
            >
              <img src={logo} />
            </a>
            <p className="footer-text">
              We are an innovative, TechZone and software
              <br /> development company that delivers forefront <br />
              engineering solutions.
            </p>
          </div>
          <div className="col-3">
            <h3 className="footer-link-head"> Links</h3>
            <ul className="nav flex-column">
              <li className="nav-item mb-4">
                <a href="#" className="nav-link p-0 footer-list-text">
                  Home
                </a>
              </li>
              <li className="nav-item mb-4">
                <a
                  onClick={executeScroll}
                  className="nav-link p-0 footer-list-text"
                >
                  Courses
                </a>
              </li>
              <li className="nav-item mb-4">
                <a
                  onClick={executeScrollAboutus}
                  className="nav-link p-0 footer-list-text"
                >
                  About us
                </a>
              </li>
              <li className="nav-item mb-4">
                <a
                  onClick={executeScrollContact}
                  className="nav-link p-0 footer-list-text"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className="col-3">
            <p className="footer-link-head"> Follow us</p>
            <ul className="nav flex-column">
              <li className="nav-item mb-3">
                <a
                  target="_blank"
                  href="https://in.linkedin.com/in/m-squared-training-and-development-center-a46527228/"
                  className="nav-link p-0 footer-list-text"
                >
                  <img src={linkedin} />
                </a>
              </li>
              <li className="nav-item mb-3">
                <a
                  target="_blank"
                  href="https://www.instagram.com/msquared_training_center/"
                  className="nav-link p-0 footer-list-text"
                >
                  <img src={insta} />
                </a>
              </li>
              
              <li className="nav-item mb-3">
                <a
                  target="_blank"
                  href="https://www.youtube.com/channel/UCN8DlLQHTVNyYTpKglO-q0w"
                  className="nav-link p-0 footer-list-text"
                >
                  <img src={youtube} />
                </a>
              </li>
              <li className="nav-item mb-3">
                <a
                  target="_blank"
                  href="https://www.facebook.com/trainingm2"
                  className="nav-link p-0 footer-list-text"
                >
                  <img src={fb} />
                </a>
              </li>
            </ul>
          </div>
        </footer>
        <div className="footer-bottom">
          <p>
            {" "}
            COPYRIGHT © 2024 M-SQUARED TRAINING CENTER | ALL RIGHTS RESERVED
          </p>
        </div>
      </div> */}
    </div>
  );
}

export default Footer;
